
export function getUTMParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source"),
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
    utm_content: params.get("utm_content"),
    utm_term: params.get("utm_term"),
    placement: params.get("placement"),
    utm_id: params.get("utm_id"), // optional: add this if used in tracking
  };
}

// Same keys as getUTMParams(), but sourced from a Vue-Router `to.query` object.
// Used by the global router.beforeEach hook, where window.location.search still
// reflects the previous URL (address bar not yet updated in history mode).
export function getUTMParamsFromQuery(query = {}) {
  return {
    utm_source: query.utm_source || null,
    utm_medium: query.utm_medium || null,
    utm_campaign: query.utm_campaign || null,
    utm_content: query.utm_content || null,
    utm_term: query.utm_term || null,
    placement: query.placement || null,
    utm_id: query.utm_id || null,
  };
}

export function getCleanUtm() {
  try {
    const raw = JSON.parse(localStorage.getItem("utm_data") || "{}");

    // Remove null or empty-string values
    return Object.fromEntries(
      Object.entries(raw).filter(function ([, v]) {
        return v != null && v !== "";
      })
    );
  } catch (e) {
    console.warn("[UTM] Corrupted JSON in localStorage:", e);
    return {};
  }
}

// export function getCleanUtm() {
//   try {
//     const raw = JSON.parse(localStorage.getItem("utm_data") || "{}");

//     // Remove null or empty-string values
//     return Object.fromEntries(
//       Object.entries(raw).filter(function ([, v]) {
//         return v != null && v !== "";
//       })
//     );
//   } catch (e) {
//     console.warn("[UTM] Corrupted JSON in localStorage:", e);
//     return {};
//   }
// }

// src/utils/helper.js or src/helpers/utm.js
